import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import EventsAPI from '../../api/events';
import { throwErrorMessage } from '../utils/api';

export const state = {
    records: [],
    uiFlags: {
        isFetchingItem: false,
        isFetching: false,
        isCreating: false,
        isDeleting: false,
        isUpdating: false,
    },
};

export const getters = {
    getEvents($state) {
        return $state.records;
    },
    getEvent: $state => id => {
        return $state.records.find(record => record.id === Number(id));
    },
    getUIFlags($state) {
        return $state.uiFlags;
    },
};

export const actions = {
    get: async function getEvents({ commit }, params = {}) {
        commit(types.SET_EVENTS_UI_FLAG, { isFetching: true });
        try {
            const response = await EventsAPI.get(params);
            commit(types.SET_EVENTS, response.data.payload || []);
        } catch (error) {
            // Ignore error
        } finally {
            commit(types.SET_EVENTS_UI_FLAG, { isFetching: false });
        }
    },
    create: async function createEvent({ commit }, eventObj) {
        commit(types.SET_EVENTS_UI_FLAG, { isCreating: true });
        try {
            const response = await EventsAPI.create(eventObj);
            commit(types.ADD_EVENT, response.data);
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_EVENTS_UI_FLAG, { isCreating: false });
        }
    },
    update: async ({ commit }, { id, ...updateObj }) => {
        commit(types.SET_EVENTS_UI_FLAG, { isUpdating: true });
        try {
            const response = await EventsAPI.update(id, updateObj);
            commit(types.EDIT_EVENT, response.data);
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_EVENTS_UI_FLAG, { isUpdating: false });
        }
    },
    delete: async ({ commit }, id) => {
        commit(types.SET_EVENTS_UI_FLAG, { isDeleting: true });
        try {
            await EventsAPI.delete(id);
            commit(types.DELETE_EVENT, id);
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_EVENTS_UI_FLAG, { isDeleting: false });
        }
    },
    toggleActive: async ({ commit }, eventId) => {
        commit(types.SET_EVENTS_UI_FLAG, { isUpdating: true });
        try {
            const response = await EventsAPI.toggleActive(eventId);
            commit(types.EDIT_EVENT, response.data);
        } catch (error) {
            throwErrorMessage(error);
        } finally {
            commit(types.SET_EVENTS_UI_FLAG, { isUpdating: false });
        }
    },
};

export const mutations = {
    [types.SET_EVENTS_UI_FLAG]($state, data) {
        $state.uiFlags = {
            ...$state.uiFlags,
            ...data,
        };
    },
    [types.ADD_EVENT]: MutationHelpers.setSingleRecord,
    [types.SET_EVENTS]: MutationHelpers.set,
    [types.EDIT_EVENT]: MutationHelpers.update,
    [types.DELETE_EVENT]: MutationHelpers.destroy,
};

export default {
    namespaced: true,
    actions,
    state,
    getters,
    mutations,
};
